import Chinese from '@uppy/locales/lib/zh_CN';
Chinese.strings['noDuplicates'] = '无法添加重复的文件“%{fileName}”，它已经存在';
export default Chinese;
